import Button from 'components/button';
import { CheckboxGroup, Field, Form, LocalitySelect } from 'components/forms';
import { refundForm } from 'components/forms/decorators';
import OptionsSidebar from 'components/options-sidebar';
import SectionBanner from 'components/section-banner';
import SectionTitle from 'components/section-title';
import createCLDealerCropsOrderMutation from 'graphql/mutations/orders/create-cl-dealer-crops-order.gql';
import React, { Component, Fragment } from 'react';
import styles from './styles.css';

@refundForm(createCLDealerCropsOrderMutation)
export default class CLDealerCropsCreate extends Component {
    render() {
        return (
            <div className={styles.root}>
                <SectionBanner />
                <SectionTitle title='Campo Líder Distribuidor' />
                <div className={styles.gridContainer}>
                    <OptionsSidebar
                        refundType='cl'
                        userType='dealer'
                        links={['refund', 'kits', 'trialSigns']}
                    />
                    <div className={styles.formContainer}>
                        <Form
                            fields={[
                                {key: 'locality'},
                                {key: 'crops', initial: []},
                            ]}
                            errors={this.props.errors}
                            onSubmit={this.props.onSubmit}>
                            {({getFieldProps, renderErrors, isValid}) => (
                                <Fragment>
                                    <div className={styles.title}>Pedido de Bolsas</div>
                                    <Field label='Localidad'>
                                        <LocalitySelect
                                            {...this.props.getLocalitySelectProps(getFieldProps('locality'))}
                                        />
                                        {renderErrors('locality')}
                                    </Field>
                                    <Field label='Cultivos a sembrar'>
                                        <CheckboxGroup
                                            options={[
                                                {label: 'Soja', value: 'Soja'},
                                                {label: 'Maíz', value: 'Maiz'},
                                                {label: 'Trigo', value: 'Trigo'},
                                                {label: 'Girasol', value: 'Girasol'},
                                            ]}
                                            {...getFieldProps('crops')}
                                        />
                                        {renderErrors('crops')}
                                    </Field>
                                    {renderErrors('__all__')}
                                    <Form.Actions>
                                        <Button theme='yellow' disabled={!isValid() || this.props.loading}>
                                            {this.props.loading ? 'ENVIANDO...' : 'ENVIAR'}
                                        </Button>
                                    </Form.Actions>
                                </Fragment>
                            )}
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/refunds/cl-dealer/crops/index.js